import React, { Component } from "react";
import { Button, FormGroup, FormControl, ProgressBar, InputGroup } from "react-bootstrap";
import ShowModalPopUp from '../ShowModalPopUp';
import '../../Resources/css/Login.css';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {LoginAction, closeModalPopUp} from './LoginActions';
import iQumex from '../../Resources/images/iQumex-logo.jpg'
import logo from '../../Resources/images/logo.png'
import _ from 'lodash'

 class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      password: "",
      passwordtype:"password",
      now:20
    };
  }
 
  validateForm() {
    if(this.state.id && this.state.id.length > 0 && this.state.password.length > 5)
    return true;
}

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.isPending === false && !_.isEmpty(nextProps.menuOptions) && nextProps.showerror === false){
      this.signIN(_.cloneDeep(nextProps.menuOptions))
    }
  }
  handleSubmit = event => {
    event.preventDefault();   
  }
  calculateNow(){
    if(this.state.now < 80){
    this.setState((prevState) =>{
      return {now: prevState.now+20};
    })
  }
    return this.state.now
  }
  signIN = (data) =>{   
    this.props.history.push(data[0].path)
  }
  viewPassword = (prop) => {
    this.setState({passwordtype:prop}) 
   }
  render() {
    return (
      <div className="login-wrapper">
        {this.props.isPending === true ?
          <ProgressBar animated now={this.calculateNow()} /> : null }
        <div className={this.props.isPending === true ? 'login_form disabled' : 'login_form'}>
          <div style={{'textAlign':'center'}}>
          <img src={iQumex} className='Project_iQumexLogo' alt={'logo1'} width='100%'/>
        <p className='logo'><img src={logo} className='Project_logo' alt={'logo'}/></p>
       </div>
        <div className='login_content'>
        <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="id" >          
            <FormControl
              autoFocus
              type="id"
              value={this.state.id}
              onChange={this.handleChange}
              placeholder = {"User ID"}
            />
          </FormGroup>
          <FormGroup controlId="password">
          <InputGroup>
           <FormControl
              value={this.state.password}
              onChange={this.handleChange}
              type={this.state.passwordtype}
              placeholder = {"Password"}
            />
             {!_.isEmpty(this.state.password) ?
             <InputGroup.Append>
              <InputGroup.Text id="basic-addon2">{this.state.passwordtype === "password" ?     
                <i class='fas fa-eye' onClick={()=>this.viewPassword('text')} /> :
                <i class='fas fa-eye-slash' onClick={()=>this.viewPassword('password')} /> }</InputGroup.Text>
              </InputGroup.Append> : null }
            </InputGroup>
          </FormGroup>
          <Link to='/ForgotPassword' className='forgot alignRight'>Forgot Password ?</Link>
          <br/>          
          <Button
            disabled={!this.validateForm()}
            type="submit"
            className="alignLeft buttonwidth"
            onClick={()=>this.props.action(this.state.id, this.state.password)}
          >
            Login
          </Button>
          </form>
            {(this.props.showerror === true) ?
            <ShowModalPopUp message={this.props.errmessage} 
            falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
          <div class="clearfix"></div>
          <div class="separator"></div>
        </div> 
        </div>
      </div>
    );
  }
}
function mapStateToProps(state){
  return{
    loginAction: state.LoginReducer.loginAction,
    errmessage: state.LoginReducer.errmessage,
    showerror: state.LoginReducer.showerror,    
    isPending: state.LoginReducer.isPending,
    menuOptions:state.LoginReducer.menuOptions
  }  
}

const mapDispatchToProps = (dispatch) => ({
  action: (a, b, c) => dispatch(LoginAction(a, b, c)),
  closeModalPopUp: () => dispatch(closeModalPopUp()),
})


export default connect(mapStateToProps, mapDispatchToProps)(Login);